var _style, _text, _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHroneLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1508.8 777.1",
    style: {
      enableBackground: "new 0 0 1508.8 777.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A82D2E;stroke:#A82D2E;stroke-width:21;stroke-miterlimit:10;}\n\t.st1{font-family:'ArialMT';}\n\t.st2{font-size:451.27px;}\n\t.st3{fill:#105DA5;}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2.968750e-05 754.6016)",
    className: "st0 st1 st2"
  }, "HROne")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.8,369c0,0,42.7-87.4,142.3-87.4c99.5,0,142.3,87.4,142.3,87.4s-64.8-37-142.3-37 C90.6,332,25.8,369,25.8,369z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 167.1,
    cy: 223,
    r: 27.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.8,368.8c0,0,42.7-87.4,142.3-87.4c99.5,0,142.3,87.4,142.3,87.4s-64.8-37-142.3-37 S348.8,368.8,348.8,368.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 490,
    cy: 222.7,
    r: 27.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.8,187.9c0,0,42.7-87.4,142.3-87.4c99.5,0,142.3,87.4,142.3,87.4s-64.8-37-142.3-37 S186.8,187.9,186.8,187.9z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 328.1,
    cy: 41.9,
    r: 27.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHroneLogoLarge);
export default __webpack_public_path__ + "static/media/hroneLogoLarge.0c79befad3a581ccce9d2f53a3216d94.svg";
export { ForwardRef as ReactComponent };